const contact = () => {
  let autofill = document.querySelector('.contact__form-autofill');
  let phone = document.querySelector('input[name="phone"]');
  let zip = document.querySelector('input[name="zip"]');
  let prefecture = document.querySelector('input[name="prefecture"]');

  if(autofill != undefined) {
    autofill.setAttribute("onclick", "AjaxZip3.zip2addr('zip','','prefecture','addr', 'street')");
  }

  if(phone != undefined) {
    phone.setAttribute('maxlength', '11');
    phone.setAttribute('onkeypress', 'return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))');
  }

  if(zip != undefined) {
    zip.setAttribute('maxlength', '7');
    zip.setAttribute('onkeypress', 'return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))');
  }

  if(prefecture !=undefined) {
    prefecture.setAttribute('readonly', 'readonly');
  }

  //contact dropdown
  const dropdown = document.querySelector('.contact__form-select--prefecture')
  const dropdown_items = document.querySelectorAll('.contact__form-select-item')
  const dropdown_input = document.querySelector('.pref')

  if(dropdown != undefined) {

    dropdown.onclick = () => dropdown.classList.toggle('contact__form-select--active')

    for(let dropdown_item of dropdown_items) {
      dropdown_item.onclick = () => dropdown_input.value = dropdown_item.innerHTML
    }
  }
}

export default contact